import { Link } from 'react-router-dom';
import { PATHS } from '@/constants/paths';
import Avatar from '@/assets/images/A_UserAvatar.png';
import styles from './A_UserAvatar.module.css';
import cn from 'classnames';
import { getMediaUrl } from '@/utils/mediaUrl';

interface A_UserAvatarProps {
  width?: number;
  height?: number;
  isLink?: boolean;
  className?: string;
  alt?: string;
  hasBorder?: boolean;
  src?: string;
}

export default function A_UserAvatar({
  width = 40,
  height = 40,
  isLink = false,
  className = '',
  alt = 'User avatar',
  hasBorder = false,
  src,
}: A_UserAvatarProps) {
  const normalizedSrc = typeof src === 'string' ? src.trim() : '';
  const imageSrc = getMediaUrl(normalizedSrc || Avatar);

  const avatarElement = (
    <img
      src={imageSrc}
      alt={alt}
      width={width}
      height={height}
      className={cn(styles.avatar, className, {
        [styles.hasBorder]: hasBorder,
      })}
    />
  );

  if (isLink) {
    return (
      <Link to={PATHS.PROFILE} className={styles.link}>
        {avatarElement}
      </Link>
    );
  }

  return avatarElement;
}
